import { z } from 'zod';

export const DiscountCreateFormSchema = z
  .object({
    name: z.string().min(1, '*Discount name is required'),
    amount: z.coerce.number().optional(),
    amountType: z
      .enum(['cash', 'percentage'], {
        errorMap: () => ({
          message: '*Select one of the type',
        }),
      })
      .optional(),
    category: z.enum(['customAmount', 'fixedAmount'], { required_error: '*Select one of the category' }),
    discountTypeCustom: z.enum(['cash', 'percentage']).nullable().optional(),
    outlet_ids: z.array(z.coerce.number()).min(1, '*Assign at least one outlet'),
  })
  .superRefine(({ category, discountTypeCustom, amount, amountType }, ctx) => {
    if (category === 'customAmount' && !discountTypeCustom) {
      ctx.addIssue({
        path: ['discountTypeCustom'],
        message: '*Select one of the promo type',
        code: 'custom',
      });
    }

    if (category === 'fixedAmount' && !amount) {
      ctx.addIssue({
        path: ['amount'],
        code: 'too_small',
        minimum: 1,
        type: 'number',
        inclusive: true,
        message: '*Insert amount value at least 1',
      });
    }

    if (category === 'fixedAmount' && !amountType) {
      ctx.addIssue({
        path: ['amountType'],
        code: 'custom',
        message: '*Select amount type',
      });
    }

    if (amountType === 'percentage' && amount && amount > 100) {
      ctx.addIssue({
        path: ['amount'],
        code: 'custom',
        message: '*Amount percentage can not be higher than 100%',
      });
    }
  });

export type DiscountCreateFormSchemaType = z.infer<typeof DiscountCreateFormSchema>;
